export default "__VITE_ASSET__D4wbnXKR__"